export default __webpack_public_path__ + "static/media/students.111e8d52.svg";